import { isNil, isObject, negate } from 'lodash-es'

import { Data } from '../../../domain'
import { InterValidationFunction } from './types'

export const isNotNil = <T>(value: T | null | undefined): value is T =>
  negate(isNil)(value)

export const required = (option: boolean) => (value: unknown) =>
  !option
    ? true
    : isObject(value)
    ? Object.values(value).every(isNotNil)
    : isNotNil(value)

export const onlyAccept = (accept: boolean) => (value: boolean | undefined) =>
  value === accept

export const raiseError = (message: string) => {
  throw new Error(message)
}

export const isNilValidationCurry: (
  interValidationFunction: InterValidationFunction,
) => InterValidationFunction =
  (func) => (option, formKey) => (value: string, formValues: Data) => {
    const formValue = formValues[formKey]

    return isNil(formValue) || isNil(value)
      ? true
      : func(option, formKey)(value, formValues)
  }
